import { defaultFilterConfig, } from '../../models/b2b/add-manage-users';
import { apiB2B } from '../axios-client';
import { MANAGE_USERS_PAGE_SIZE } from '../../constants/general';
import { B2B_MANAGE_USERS_DELETE_PATH, B2B_MANAGE_USERS_PATH, B2B_MANAGE_USERS_ADD_PATH, B2B_MANAGE_USERS_UPDATE_PATH, B2B_MANAGE_USERS_MULTI_DELETE_PATH, B2B_MANAGE_USERS_RESEND_INVITE_PATH, B2B_MANAGE_USERS_MULTI_RESEND_INVITES_PATH, B2B_MANAGE_USERS_BULK_ADD_PATH, B2B_MANAGE_GET_POLICY_PATH, B2B_MANAGE_SAVE_POLICY_PATH, B2B_PRO_TRADE_CREDIT_RETRIEVE_PATH, B2B_PRO_TRADE_CREDIT_RETRIEVE_BY_USER_PATH, } from '../../constants/links';
import { mapPaymentCardToViewModel, mapToMultiResendInviteRequest, } from '../../utils/add-manage-users';
import { b2bAccountApi } from './account';
export var addManageUsersApi = {
    getUsers: function (sortConfig, filterConfig) {
        return apiB2B.post(B2B_MANAGE_USERS_PATH, {
            UserSearch: filterConfig || defaultFilterConfig,
        }, {
            params: {
                ps: MANAGE_USERS_PAGE_SIZE,
                pn: (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.page) || 1,
                sb: (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.sortBy) || 'addedDate',
                asc: (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.ascendingOrder) || false,
            },
        });
    },
    deleteUser: function (userId) {
        return apiB2B.delete("".concat(B2B_MANAGE_USERS_DELETE_PATH, "/").concat(userId));
    },
    addUser: function (payload) {
        return apiB2B.post(B2B_MANAGE_USERS_ADD_PATH, {
            userRequest: payload,
        });
    },
    downloadUsers: function (filename, filetype) {
        return apiB2B.get("".concat(B2B_MANAGE_USERS_PATH, "/").concat(filetype, "?fileName=").concat(filename), {
            params: { filename: filename },
            responseType: 'blob',
        });
    },
    resendInvite: function (payload) {
        return apiB2B.post(B2B_MANAGE_USERS_RESEND_INVITE_PATH, { userRequest: payload });
    },
    updateUser: function (payload) {
        return apiB2B.put(B2B_MANAGE_USERS_UPDATE_PATH, {
            userRequest: payload,
        });
    },
    multiRemoveUsers: function (payload) {
        return apiB2B.post(B2B_MANAGE_USERS_MULTI_DELETE_PATH, {
            users: { user: payload },
        });
    },
    multiResendInvites: function (payload, isInviteExpirationEnabled) {
        var selectedPendingInviteUserData = mapToMultiResendInviteRequest(payload, isInviteExpirationEnabled);
        return apiB2B.post(B2B_MANAGE_USERS_MULTI_RESEND_INVITES_PATH, {
            multiEmailSendRequest: { users: selectedPendingInviteUserData },
        });
    },
    bulkAdd: function (data) {
        return apiB2B.post(B2B_MANAGE_USERS_BULK_ADD_PATH, {
            users: {
                user: data,
            },
        });
    },
    getPolicy: function () { return apiB2B.get(B2B_MANAGE_GET_POLICY_PATH); },
    saveViewPurchaseHistoryPolicy: function (payload) {
        return apiB2B.put(B2B_MANAGE_SAVE_POLICY_PATH, payload);
    },
    getPTC: function () {
        return Promise.all([
            apiB2B.get(B2B_PRO_TRADE_CREDIT_RETRIEVE_PATH),
            b2bAccountApi.profileDetails(),
        ]).then(function (_a) {
            var paymentResponse = _a[0], profileResponse = _a[1];
            return mapPaymentCardToViewModel(paymentResponse.data.paymentCards.paymentCard, profileResponse.data.accountProfile.customerProfile.businessName);
        });
    },
    getPTCByUserId: function (userId) {
        return apiB2B
            .get(B2B_PRO_TRADE_CREDIT_RETRIEVE_BY_USER_PATH(userId))
            .then(function (response) {
            return mapPaymentCardToViewModel(response.data.paymentCards.paymentCard, 
            // businessName can be empty because all we need is the payment id
            '');
        });
    },
    updateUserTendersPermissions: function (payload, authorizedUserId) {
        return apiB2B.post("".concat(B2B_MANAGE_USERS_PATH, "/").concat(authorizedUserId, "/payments"), payload);
    },
};
